/* eslint-disable max-classes-per-file */
import {
  BookingStatusEnums,
  PaymentStatusEnums,
} from "@/types/product/account/history";
import dayjs from "@/utils/dayjs";

import { ExpirePaymentDatePresenter } from "./historyBookingCommonInterface";

export interface RequestGetHistoryInterface {
  limit: number;
  page: number;
  type: string;
}

export interface RequestGetCheckCancelStatusInterface {
  bookingInternalNo: string;
}

export interface RequestGetDetailHistoryInterface {
  bookingInternalNo: string | null;
}

export class ResponseGetCheckCancelStatusPresenter {
  status: boolean;

  data: {
    rsvnId: string;
    bookingInternalNumber: string;
    refundNumber: string;
    requestDate: string;
    expectedRefundDate: string;
    refundToCustomerDate: string;
    refundToBankStatus: string;
    refundAmount: string;
    refundFee: string;
    currency: string;
    refundStatus: string;
    updatedAt: string;
  };

  message?: string;

  constructor(data: any) {
    this.status = data?.status || false;
    this.data = {
      rsvnId: data?.data?.rsvn_id || "",
      bookingInternalNumber: data?.data?.booking_internal_number || "",
      refundNumber: data?.data?.refund_number || "",
      requestDate: data?.data?.request_date || "",
      expectedRefundDate: data?.data?.expected_refund_date || "",
      refundToCustomerDate: data?.data?.refund_to_customer_date || "",
      refundToBankStatus: data?.data?.refund_to_bank_status || "",
      refundAmount: data?.data?.refund_amount || "",
      refundFee: data?.data?.refund_fee || "",
      currency: data?.data?.currency || "",
      refundStatus: (data?.data?.refund_status || "").toLocaleLowerCase(),
      updatedAt: data?.data?.updated_at || "",
    };
    this.message = data?.message || "";
  }
}
export class DataHotelListPresenter {
  type: string;

  rsvnId: string;

  rsvnStatusId: string;

  bookingInternalNo: string;

  pinCode: string;

  paymentStatus: string;

  bookingStatus: string;

  reservationNo: string;

  bookingDate: string;

  bookingDateLang: string;

  hotelId: string;

  hotelName: string;

  hotelSlug: string;

  imageCover: string;

  isFavourite: boolean;

  checkIn: string | null;

  contact: {
    title: string;

    firstname: string;

    lastname: string;

    countryOfPassport: string;

    email: string;

    phone: string;
  };

  roomCriteria: {
    roomBoardName: string;
    roomName: string;
    checkIn: string;
    checkOut: string;
    numberOfRoom: string;
    adult: string;
    child: string;
    rentalDays: number;
  };

  payAtHotel: boolean;

  freeCancellation: boolean;

  location: {
    countrySlug: string;

    citySlug: string;

    areaSlug: string;

    cityName: string;
  };

  expirePaymentDate: ExpirePaymentDatePresenter;

  refundStatus: string;

  isPaylater: boolean;

  paylaterDeadlineDate: string;

  paylaterDeadlineDateLang: string;

  paylaterChargedDate: string;

  isConjobsFail: boolean;

  constructor(data: any) {
    this.type = data?.type || "";
    this.rsvnId = data?.rsvnId || "";
    this.rsvnStatusId = data?.rsvnStatusId || "";
    this.bookingInternalNo = data?.bookingInternalNo || "";
    this.pinCode = data?.pinCode || "";
    this.paymentStatus = (data?.paymentStatus || "").toLocaleLowerCase();
    this.reservationNo = data?.reservationNo || "";
    this.bookingDate = data?.bookingDate || "";
    this.bookingDateLang = data?.bookingDateLang || "";
    this.hotelId = data?.hotelId || "";
    this.hotelName = data?.hotelName || "";
    this.hotelSlug = data?.hotelSlug || "";
    this.imageCover = data?.imageCover || "";
    this.isFavourite = data?.isFavourite;
    this.checkIn = data?.checkIn || "";
    this.contact = {
      title: data?.contact?.title || "",
      firstname: data?.contact?.firstname || "",
      lastname: data?.contact?.lastname || "",
      countryOfPassport: data?.contact?.countryOfPassport || "",
      email: data?.contact?.email || "",
      phone: data?.contact?.phone || "",
    };
    this.roomCriteria = {
      roomBoardName: data?.roomCriteria?.roomBoardName || "",
      roomName: data?.roomCriteria?.roomName || "",
      checkIn: data?.roomCriteria?.checkIn || "",
      checkOut: data?.roomCriteria?.checkOut || "",
      numberOfRoom: data?.roomCriteria?.numberOfRoom || "",
      adult: data?.roomCriteria?.adult || "",
      child: data?.roomCriteria?.child || "",
      rentalDays: data?.roomCriteria?.rentalDays || null,
    };
    this.payAtHotel = data?.payAtHotel || false;
    this.freeCancellation = data?.freeCancellation || false;
    this.location = {
      countrySlug: data?.location?.countrySlug || "",
      citySlug: data?.location?.citySlug || "",
      areaSlug: data?.location?.areaSlug || "",
      cityName: data?.location?.cityName || "",
    };
    this.expirePaymentDate = new ExpirePaymentDatePresenter(
      data?.expirePaymentDate,
    );
    this.refundStatus = data?.refundStatus || "";
    this.isPaylater = data?.isPaylater || false;
    this.paylaterDeadlineDate = data?.paylaterDeadlineDate || "";
    this.paylaterDeadlineDateLang = data?.paylaterDeadlineDateLang || "";
    this.paylaterChargedDate = data?.paylaterChargedDate || "";

    // NOTE - เช็ค แวลาปัจจุบัน < เวลา conjob และ status "paymentStatus" ยังไม่เปลี่ยนเป็น "paid" แปลว่า conjob fail
    const isConjobsFail =
      dayjs(`${this.paylaterDeadlineDate} 08:00:00`).diff(dayjs(), "second") <
        0 &&
      this.isPaylater &&
      this.paymentStatus === PaymentStatusEnums.PAYLATER;

    this.bookingStatus = (
      isConjobsFail ? BookingStatusEnums.UNPAID : data?.bookingStatus || ""
    ).toLocaleLowerCase();
    this.isConjobsFail = isConjobsFail;
  }
}

export class ResultsHistoryPresenter {
  type: string;

  step: string;

  countData: number;

  data: DataHotelListPresenter[];

  constructor(data: any) {
    this.type = data?.type || "";
    this.step = data?.step || "";
    this.countData = (data?.count_data ?? data?.countData) || 0;
    this.data = (data?.data || []).map(
      (results: any) => new DataHotelListPresenter(results),
    );
  }
}

export class ResponseGetHistoryPresenter {
  results: ResultsHistoryPresenter[];

  status: boolean;

  constructor(data: any) {
    this.status = data?.status || false;
    this.results = (data?.results || []).map(
      (results: any) => new ResultsHistoryPresenter(results),
    );
  }
}

export class ResponseGetCancelFeePresenter {
  status: boolean;

  cancelEnable: boolean;

  charge: number;

  currency: string;

  original: string;

  message?: string;

  constructor(response: any) {
    this.status = response?.status || false;
    this.cancelEnable = response?.cancelEnable || false;
    this.charge = (response?.charge ?? response?.data?.charge) || 0;
    this.currency = (response?.currency ?? response?.data?.currency) || "";
    this.original = response?.original || "";
    this.message = response?.message || "";
  }
}
